export interface Sizing {
  small: '343px';
  medium: '440px';
  large: '620px';
}

export const sizing: Sizing = {
  small: '343px',
  medium: '440px',
  large: '620px',
};
